import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCjsDRLdVDAmJD7aZBmbYl5fhcF85_fiGw',
        libraries: 'places' // necessary for places input
    }
})
